import type { ResourceAccessListItem, ResourceAccessSummary } from '@einhaus/project314-types';

type ResourceAccessBadgeProps = {
    access: Pick<ResourceAccessSummary, 'canConsume' | 'canCopy' | 'canEdit' | 'ownedByUser' | 'role'> | ResourceAccessListItem;
};

const ResourceAccessBadge = ({ access }: ResourceAccessBadgeProps) => {
    if (access.ownedByUser) {
        return (
            <span className="inline-flex items-center gap-1 rounded-full border border-emerald-800/50 bg-emerald-950/30 px-2 py-0.5 text-xs font-medium text-emerald-400">
                <svg className="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                    <path clipRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" fillRule="evenodd" />
                </svg>
                Owned
            </span>
        );
    }

    if (access.canEdit) {
        return (
            <span className="inline-flex items-center gap-1 rounded-full border border-amber-800/50 bg-amber-950/30 px-2 py-0.5 text-xs font-medium text-amber-400">
                <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                    />
                </svg>
                Can Edit
            </span>
        );
    }

    if (access.canConsume) {
        return (
            <span className="inline-flex items-center gap-1 rounded-full border border-sky-800/50 bg-sky-950/30 px-2 py-0.5 text-xs font-medium text-sky-400">
                <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                        d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                    />
                </svg>
                Can Use
            </span>
        );
    }

    if (access.canCopy) {
        return (
            <span className="inline-flex items-center gap-1 rounded-full border border-violet-800/50 bg-violet-950/30 px-2 py-0.5 text-xs font-medium text-violet-300">
                <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                    />
                </svg>
                Can Copy
            </span>
        );
    }

    return (
        <span className="inline-flex items-center gap-1 rounded-full border border-zinc-700/50 bg-zinc-900/50 px-2 py-0.5 text-xs font-medium text-zinc-400">
            <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
                <path
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                />
            </svg>
            View Only
        </span>
    );
};

export default ResourceAccessBadge;
